import { Fetcher } from "openapi-typescript-fetch";
function scopeString(scopes) {
    if (!scopes) {
        return undefined;
    }
    const s = [];
    if (scopes.tenant) {
        s.push(`tenant-${scopes.tenant}`);
    }
    if (scopes.as) {
        s.push(`as-${scopes.as}`);
    }
    if (scopes.admin) {
        s.push(`admin-${scopes.admin}`);
    }
    if (scopes.sjAdmin) {
        s.push(`sj-admin`);
    }
    if (!s.length) {
        return undefined;
    }
    return s.join(" ");
}
// The only client side use for the AuthClient is to exchange a Cognito token for a service access token.
// The token can be cached until it expires.
export class AuthClient {
    // note: don't pass baseUrl. In a real UI, requests should be to the same origin as the UI.
    // this is just for testing.
    constructor(baseUrl) {
        this.fetcher = Fetcher.for();
        this.fetcher.configure({
            baseUrl: baseUrl,
        });
        // validate the endpoint
        this.fetcher.path("/svc/auth/token").method("post").create();
        this.baseUrl = baseUrl || window.location.protocol + "//" + window.location.host;
    }
    // exchange a Cognito token for a svc-auth token OR change the scope of an existing svc-auth token
    exchangeForAccessToken({ subjectToken, scopes, }) {
        const abortController = new AbortController();
        const abort = () => abortController.abort();
        const data = {
            subject_token: subjectToken !== null && subjectToken !== void 0 ? subjectToken : "",
            subject_token_type: "urn:ietf:params:oauth:token-type:jwt",
            grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
        };
        const scope = scopeString(scopes);
        if (scope) {
            data.scope = scope;
        }
        // openapi-typescript-fetch doesn't support form body :facepalm:
        // https://github.com/ajaishankar/openapi-typescript-fetch/issues/31
        // Using fetch directly for now.
        // Typescript verified above that the request is valid.
        const init = {
            signal: abortController.signal,
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: asFormData(data),
            credentials: "include",
        };
        return {
            abort,
            promise: fetch(this.baseUrl + "/svc/auth/token", init),
        };
    }
}
function asFormData(data) {
    const form = new URLSearchParams();
    for (const [key, value] of Object.entries(data)) {
        if (Array.isArray(value)) {
            value.forEach(v => form.append(key, v));
        }
        else {
            form.append(key, value);
        }
    }
    return form;
}
//# sourceMappingURL=auth.js.map